import React from "react"
import ReactDOM from "react-dom/client"

import { RecentlyViewedSimilarItems, type Props } from "./component"

const App = class extends HTMLElement {
  root: ReactDOM.Root | null = null

  connectedCallback() {
    const props: Partial<Props> = {}

    this.querySelectorAll("script").forEach((script) => {
      try {
        const data = JSON.parse(script?.innerHTML)
        const name = script.getAttribute("name")

        if (!name) return

        props[name as keyof Props] = data
      } catch (error) {
        console.error(error)
      }
    })

    if (!this.root) this.root = ReactDOM.createRoot(this)
    this.root.render(<RecentlyViewedSimilarItems {...(props as Props)} />)
  }
}

customElements.define("ss-recently-viewed-similar-items", App)
